import { observable } from 'mobx'
import {
  EditableField,
  editIlmoitettuArvo,
  editVtjArvo,
  Etunimet,
  finalEditableFieldValue,
  IncludeApostille,
  IncludeKaannos,
  KaannosKieli,
  Sukunimi,
} from 'todistukset-common/src/vtj/types/editable-field.type'
import {
  UaetSpouseAForm,
  UaetUiForm,
} from 'todistukset-common/src/vtj/types/form-types.type'
import {
  TodistusAsiointikieli,
  TodistusPersonRole,
} from 'todistukset-common/src/vtj/types/todistus-person.type'
import type { TodistuksetUser } from 'todistukset-common/src/vtj/types/user'
import { isHetuIdentifiedUser } from 'todistukset-common/src/vtj/user.utils'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

export const createUaetFormStore = (
  user: TodistuksetUser | undefined,
  asiointikieli: TodistusAsiointikieli
): UaetUiForm => {
  const spouseA = getUaetPuolisoAFromUser(user, asiointikieli)
  const spouseB = {
    personRole: TodistusPersonRole.PUOLISO_B as TodistusPersonRole.PUOLISO_B,
    hetu: null,
    firstNames: null,
    lastName: null,
    birthdate: null,
    citizenshipCode: null,
    birthPlace: null,
    birthCountryCode: null,
    maritalStatus: null,
  }

  return observable({
    spouseA,
    spouseB,
    placeOfMarriage: null,
    todistusLanguage: null,
    includeTranslationForm: editIlmoitettuArvo<IncludeKaannos>(null, false),
    translationFormLanguage: editIlmoitettuArvo<KaannosKieli>(null, null),
    includeApostille: editIlmoitettuArvo<IncludeApostille>(null, false),
    mailDelivery: {
      firstName: editIlmoitettuArvo<EditableField<string>>(
        null,
        finalEditableFieldValue(spouseA.firstNames)
      ),
      lastName: editIlmoitettuArvo<EditableField<string>>(
        null,
        finalEditableFieldValue(spouseA.lastName)
      ),
      streetAddress: editIlmoitettuArvo<EditableField<string>>(null, null),
      streetAddressExtras: null,
      postalCode: editIlmoitettuArvo<EditableField<string>>(null, null),
      postOffice: editIlmoitettuArvo<EditableField<string>>(null, null),
      country: editIlmoitettuArvo<EditableField<string>>(null, null),
    },
  })
}

export const useUaetForm = (): UaetUiForm => {
  const { uaetForm } = useStore()
  return uaetForm
}

const getUaetPuolisoAFromUser = (
  user: TodistuksetUser | undefined,
  asiointikieli: TodistusAsiointikieli
): UaetSpouseAForm => {
  const getHetuIdentifiedFields = (user: TodistuksetUser | undefined) => {
    if (!user || !isHetuIdentifiedUser(user)) {
      return {
        hetu: null,
        maritalStatus: null,
        citizenshipCode: null,
        birthCountryCode: null,
        birthPlaceVTJ: null,
      }
    }

    return {
      hetu: user.hetu,
      maritalStatus: user.maritalStatus,
      citizenshipCode: user.citizenshipCode,
      birthCountryCode: user.birthCountryCode,
      birthPlaceVTJ: user.birthPlace,
    }
  }

  const {
    hetu,
    maritalStatus,
    citizenshipCode,
    birthCountryCode,
    birthPlaceVTJ,
  } = getHetuIdentifiedFields(user)

  return observable({
    personRole: TodistusPersonRole.PUOLISO_A,
    hetu,
    firstNames: user?.firstNames
      ? editVtjArvo<Etunimet>(null, user.firstNames)
      : null,
    lastName: user?.lastName
      ? editVtjArvo<Sukunimi>(null, user.lastName)
      : null,
    citizenshipCode,
    birthPlace: null,
    birthPlaceVTJ,
    birthCountryCode,
    maritalStatus,
    sukulaisuussuhdeVakuutettu: null,
    contactInfo: {
      email: null,
      phoneNumber: null,
    },
    asiointikieli,
  })
}
